export { default } from "./CRMPermissionWarning";
